import React from "react";
import ScheduleTableCard from "../Reuse/ScheduleTableCard";
import EventImg from "../../../../assets/images/SakibBanner2.png";
import { useParams } from "react-router-dom";
import { useState } from "react";
import { useEffect } from "react";
import axios from "axios";
const ScheduleTable = () => {
  const params = useParams();
  const [postDetails, setPostDetails] = useState([]);
  const [participant, setParticipant] = useState([]);

  useEffect(() => {
    axios
      .get(`/api/admin/dashboard/post-details/${params.id}/${params.type}`)
      .then((res) => {
        if (res.data.status === 200) {
          setPostDetails(res.data.post);
          setParticipant(res.data.participant);
        }
      });
  }, []);

  return (
    <>
      <ScheduleTableCard
        props={postDetails}
        participant={participant}
        image={EventImg}
      />
    </>
  );
};

export default ScheduleTable;
